const EditSIMPlan = () => {
    return (
        <div>Edit SIMPlan</div>
    )
}

export default EditSIMPlan